var moduleName = "services.hmr";

const $inject = ["$http"];

/**
 * Handle retrieval of all HMRs for current user and contains single 'current' HMR
 */
class HmrService {

  /**
   * Init
   * @param $http
   */
  constructor($http) {
    this.$http = $http;
  }

  /**
   * Get the relevant HMRs
   * @param {Function}    handleSuccess
   * @param {Function}    handleError
   *
   * @returns {Promise}
   */
  cget(handleSuccess, handleError) {
    return this.$http.get("/app/referral/cget").then(handleSuccess, handleError);
  }

  /**
   * Check if the current pharmacist is the preferred choice for these HMRs
   * @param hmrIds
   * @param handleSuccess
   * @param handleError
   * @returns {*|Promise.<T>}
   */
  checkPreferred(hmrIds, handleSuccess, handleError) {
    return this.$http.post("/app/referral/check_preferred", {hmrIds: hmrIds}).then(handleSuccess, handleError);
  }

  /**
   * Get the relevant HMRs
   * @param {Number}      id
   * @param {Function}    handleSuccess
   * @param {Function}    handleError
   *
   * @returns {Promise}
   */
  get(id, handleSuccess, handleError) {
    return this.$http.get("/app/referral/get/" + id).then(handleSuccess, handleError);
  }

  /**
   * Accept an HMR
   * @param {Number}      id
   * @param {String}      cvn
   * @param {Function}    handleSuccess
   * @param {Function}    handleError
   *
   * @returns {Promise}
   */
  accept(id, cvn, handleSuccess, handleError) {
    return this.$http.post("/app/referral/accept/" + id, {cvn: cvn}).then(handleSuccess, handleError);
  }

  /**
   * Save the HMR report
   * @param {Number}      id
   * @param {Object}      hmr
   * @param {Function}    handleSuccess
   * @param {Function}    handleError
   *
   * @returns {Promise}
   */
  save(id, hmr, handleSuccess, handleError) {
    return this.$http.post("/app/referral/save/" + id, {hmr}).then(handleSuccess, handleError);
  }

  save_patient_details(id, hmr, handleSuccess, handleError) {
    return this.$http.post("/app/referral/save-referral-details/" + id, {hmr}).then(handleSuccess, handleError);
  }

  /**
   * Submit the HMR report
   * @param {Number}      id
   * @param {Object}      hmr
   * @param {String}      encryptedCvn
   * @param {Function}    handleSuccess
   * @param {Function}    handleError
   *
   * @returns {Promise}
   */
  submit(id, hmr, encryptedCvn, handleSuccess, handleError) {
    hmr.cvn = encryptedCvn;
    return this.$http.post("/app/referral/submit/" + id, {hmr}).then(handleSuccess, handleError);
  }

  /**
   * Get the client-side key to encrypt the CVN
   * @param handleSuccess
   * @param handleError
   */
  getClientSideKey(handleSuccess, handleError) {
    return this.$http.get("/app/referral/get_client_side_key/").then(handleSuccess, handleError);
  }

  get_refund_reasons(handleSuccess, handleError) {
    return this.$http.get("/app/referral/get-refund-reasons").then(handleSuccess, handleError);
  }

  download_original_referral(hmr_id, item, handleSuccess, handleError) {
    item = item == null? "": `/${item}`;
    return this.$http
      .get(`/app/referral/download-referral/${hmr_id}${item}`, {responseType: "arraybuffer"})
      .then(handleSuccess, handleError);
  }

  refund_request(type, id, refund_request, handleSuccess, handleError) {
    let url;
    switch (type) {
      case "pharmacist":
        url = `/app/referral/refund-request/${id}`;
        break;
      case "admin":
        url = `/admin/referral/refund-request/${id}`;
        break;
    }
    return this.$http
      .post(url, {refund_request})
      .then(handleSuccess, handleError);
  }
}

/**
 * Dependencies
 */
HmrService.$inject = $inject;

/**
 * Add to angular and make available
 */
export default angular.module(moduleName, [])
  .service("HmrService", HmrService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/hmr.service.js
 **/